module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/12-e28b0ec0d5d700a9e506e23356ba9040.webm";